import React, { ReactElement, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import StaticContentManager from '../../../services/StaticContentManager';
import { StaticContentInterface } from '../../../interfaces/StaticContentInterface';
import { faTimesCircle, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default (): ReactElement => {
  const [name, setName] = useState<string>();
  const [slug, setSlug] = useState<string>()
  const [allStaticContent, setAllStaticContent] =
    useState<StaticContentInterface[]>();


  const getAllStaticContent = async () => {
    setAllStaticContent(await StaticContentManager.getAll());
  };


  const deleteStaticContent = async (id: string) => {
    await StaticContentManager.delete(id);
    await getAllStaticContent();
  };

  useEffect(() => {
    (async () => {
      await getAllStaticContent();
    })();
  }, []);

  return (
    <>
      <div className="content">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Statische Inhalte</h1>
              </div>
              <div
                className="col-sm-6"
                style={{
                  textAlign: 'right',
                }}
              >
                <Link to={`/seminars/staticContent/editor`}>
                  <button type="button" className="btn btn-primary btn-sm">
                    Neuen statischen Inhalt anlegen
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <div className="container-fluid">
          <div className="card">
            <div className="card-body table-responsive p-0">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th
                      style={{
                        width: '90%',
                      }}
                    >
                      Name
                    </th>
                    <th style={{ width: '10%' }}>Löschen</th>
                  </tr>
                </thead>
                <tbody>
                  {allStaticContent?.map((staticContent, key) => {
                    return (
                      <tr key={key}>
                        <td>
                          <Link
                            to={`/seminars/staticContent/editor/${staticContent.id}`}
                          >
                            {staticContent.name}
                          </Link>
                        </td>
                        <td
                          onClick={() =>
                            deleteStaticContent(staticContent.id)
                          }
                          style={{
                            paddingLeft: 35,
                            fontSize: 20,
                            cursor: 'pointer',
                          }}
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
